import { FormControl, FormHelperText, TextField, styled } from '@mui/material';
import { Controller } from 'react-hook-form';

const CustomBorderTextField = styled(TextField)`
    & .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
            border-color: #3A3A3A;
        }
    }
`;

const AuthInput = (props) => {
    const {
        hookFormControl,
        varName,
        isMultiLine = false,
        disabled = false,
        dataType = 'text',
        rows = 4,
        errorMessage = null,
        autoFocus = false,
        size = "small",
        inputProps = null,
        placeholder = ""
    } = props;

    return (
        <>
            <FormControl error={errorMessage !== null} size={size}>
                <Controller
                    name={varName}
                    control={hookFormControl}
                    render={({ field }) => (
                        <CustomBorderTextField
                            id={varName}
                            type={dataType}
                            disabled={disabled}
                            autoFocus={autoFocus}
                            placeholder={placeholder}
                            multiline={isMultiLine}
                            InputProps={{ 
                                className: "rounded-full font-['Poppins-Regular'] text-[15px] border-[#3A3A3A]", 
                                inputProps: { className: "text-center" } 
                            }}
                            InputLabelProps={{
                                className: "font-['Poppins-Regular'] text-[15px]"
                            }}
                            size={size}
                            inputProps={inputProps ?? {}}
                            rows={rows}
                            {...field}
                            value={field.value ?? ""}
                        />
                        
                    )}
                />
                {errorMessage && (
                    <FormHelperText className="ml-0 font-['Poppins-Regular'] text-[11px]" id="component-error-text">
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </>
    );
};

export default AuthInput;
